import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import ServiceItemCard from "../../components/services/ServiceItemCard";
import { CategoryAPI } from "../../api";
import NotFound from "../errors/NotFound";

const Category = () => {
	const { category } = useParams();
	const [serviceCategory, setServiceCategory] = useState(null);
	const [notFound, setNotFound] = useState(false);
	const [meta, setMeta] = useState({
		title: "",
		description: "",
		keywords: "",
	});

	useEffect(() => {
		CategoryAPI.getCategory(category)
			.then((res) => {
				setServiceCategory(res.data);
				setMeta({
					title: res.data.meta_title || res.data.title,
					description: res.data.meta_description || res.data.short_description,
					keywords: res.data.meta_keywords || res.data.title,
				});
			})
			.catch(() => setNotFound(true));
	}, [category]);

	if (notFound) return <NotFound />;

	return (
		<>
			<title>{meta.title}</title>
			<meta name="description" content={meta.description} />
			<meta name="keywords" content={meta.keywords} />

			<main className="min-h-screen bg-gray-50 pb-20">
				{/* Dynamic Hero Banner */}
				<section className="relative bg-brand-600 pt-32 pb-20 px-4 overflow-hidden">
					{/* Background Decorative Element */}
					<div className="absolute top-0 right-0 w-1/3 h-full bg-brand-400/10 skew-x-[-20deg] translate-x-20" />

					<div className="max-w-7xl mx-auto relative z-10">
						<div className="flex flex-col md:flex-row items-center gap-8">
							<div className="w-24 h-24 md:w-32 md:h-32 bg-white/10 backdrop-blur-md rounded-2xl p-4 border border-white/20 shadow-2xl">
								<img
									src={serviceCategory?.icon_url}
									alt=""
									className="w-full h-full object-contain brightness-0 invert"
								/>
							</div>
							<div className="text-center md:text-left text-white">
								<nav className="flex justify-center md:justify-start items-center space-x-2 text-brand-300 text-xs font-bold uppercase tracking-widest mb-4">
									<Link
										to="/services"
										className="ha:text-white transition-colors"
									>
										Services
									</Link>
									<span>/</span>
									<span className="text-white/60">
										{serviceCategory?.title}
									</span>
								</nav>
								<h1 className="text-3xl md:text-5xl Ethnocentric mb-4 tracking-tight">
									{serviceCategory?.title}
								</h1>
								<p className="max-w-2xl text-brand-100 text-sm md:text-base leading-relaxed opacity-80">
									{serviceCategory?.description}
								</p>
							</div>
						</div>
					</div>
				</section>

				{/* Items Grid */}
				<section className="max-w-7xl mx-auto px-4 -mt-10">
					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
						{serviceCategory?.service_items?.map((service, index) => (
							<ServiceItemCard
								key={index}
								title={service.title}
								slug={service.slug}
								short_description={service.short_description}
								image={service.image}
							/>
						))}
					</div>

					{/* Empty State */}
					{serviceCategory?.service_items?.length === 0 && (
						<div className="py-20 text-center text-gray-400">
							<p className="Ethnocentric text-lg">
								No services found in this category.
							</p>
						</div>
					)}
				</section>
			</main>
		</>
	);
};

export default Category;
